import {
  SET_HEADSET_ACCOUNT,
  SET_WEEDMAP_ACCOUNT,
  SET_WEBHOOKS,
  SET_HUBLIST,
  SET_EMPLOYEE_LIST,
  SET_TEAM_LIST,
  SET_SPRING_BIG_LIST,
  SET_TOOKAN_ACCOUNT_LIST,
  SET_TOOKAN_TEAM_LIST,
  SET_WEEDMAP_TAGS,
  SET_SPENCE_ACCOUNT_LIST,
  SET_ACH_ACCOUNT_LIST,
} from '../types/integration'

import {
  acceptHeadsetAPI,
  getHeadsetAPI,
  headsetEnableSyncAPI,
  getWeedmapAccountAPI,
  createWeedmapAccountAPI,
  updateWeedmapAPIKeyAPI,
  syncWeedmapMenuAPI,
  resetSyncWeedmapMenuAPI,
  discontinueWeedmapsItemsAPI,
  updateWeedmapAccountAPI,
  deleteWeedmapAccountAPI,
  getWebHooksAPI,
  updateWebHookAPI,
  createWebHookAPI,
  getHubListAPI,
  updateShopOnFleetSettingsAPI,
  updateShopOnFleetKeyAPI,
  getEmployeeListAPI,
  getOnFleetTeamsAPI,
  getWorkersByTeamOnFleetAPI,
  syncEmployeeOnFleetAPI,
  updateEmployeeOnFleetAPI,
  createWorkerOnFleetAPI,
  onFleetTeamsByShopAPI,
  onFleetErrorLogByShopAPI,
  synchronizeTeamsAPI,
  removeWorkerOnFleetAPI,
  getSpringBigListAPI,
  createSpringBigInfoAPI,
  updateSpringBigInfoAPI,
  getTookanAccountListAPI,
  createTookanAccountAPI,
  updateTookanAccountAPI,
  updateAgentWithTookanAPI,
  createAgentWithTookanAPI,
  syncTeamWithTookanAPI,
  getTookanTeamsAPI,
  deleteTookanAccountAPI,
  getTookanErrorLogsAPI,
  resetAndDeleteWeedmapAPI,
  generateTokenAPI,
  renewTokenAPI,
  getWeedmapTagsAPI,
  updateWeedmapMappingAPI,
  getSpenceAccountListAPI,
  createSpenceAccountAPI,
  updateSpenceAccountAPI,
  deleteSpenceAccountAPI,
  syncSpringBigMembersAPI,
  getLastSyncSpringbigAPI,
  getACHAccountListAPI,
  createACHAccountAPI,
  updateACHAccountAPI,
  deleteACHAccountAPI,
} from '../api/integration'

import { addMessageCurry, commonActionAPIHit } from '../utils/api'
import { common } from '@material-ui/core/colors'

export const setHeadsetAccount = (payload) => ({
  type: SET_HEADSET_ACCOUNT,
  payload: payload,
})

export const setWeedmapAccount = (payload) => ({
  type: SET_WEEDMAP_ACCOUNT,
  payload: payload,
})

export const setWebHooks = (payload) => ({
  type: SET_WEBHOOKS,
  payload,
})

export const setHubList = (payload) => ({
  type: SET_HUBLIST,
  payload,
})

export const setEmployeeList = (payload) => ({
  type: SET_EMPLOYEE_LIST,
  payload,
})

export const setOnFleetTeams = (payload) => ({
  type: SET_TEAM_LIST,
  payload,
})

export const setSpringBigList = (payload) => ({
  type: SET_SPRING_BIG_LIST,
  payload,
})

export const setTookanAccounts = (payload) => ({
  type: SET_TOOKAN_ACCOUNT_LIST,
  payload,
})

export const setSpenceAccounts = (payload) => ({
  type: SET_SPENCE_ACCOUNT_LIST,
  payload,
})

export const setACHAccounts = (payload) => ({
  type: SET_ACH_ACCOUNT_LIST,
  payload,
})

export const setTookanTeams = (payload) => ({
  type: SET_TOOKAN_TEAM_LIST,
  payload,
})

export const setWeedmapTags = (payload) => ({
  type: SET_WEEDMAP_TAGS,
  payload,
})

export const acceptHeadset = (config) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(acceptHeadsetAPI(config), dispatch).then((config) => {
        dispatch(setHeadsetAccount(config))
        resolve(config)
      })
    })
  }
}

export const getHeadset = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getHeadsetAPI(), dispatch).then((config) => {
        dispatch(setHeadsetAccount(config))
        resolve(config)
      })
    })
  }
}

export const headsetEnableSync = (config) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(headsetEnableSyncAPI(config), dispatch).then((config) => {
        dispatch(setHeadsetAccount(config))
        resolve(config)
      })
    })
  }
}

// weedmap actions
export const getWeedmapAccount = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getWeedmapAccountAPI(), dispatch).then((config) => {
        dispatch(setWeedmapAccount(config))
        resolve(config)
      })
    })
  }
}

export const createWeedmapAccount = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(createWeedmapAccountAPI(data), dispatch).then((config) => {
        dispatch(setWeedmapAccount(config))
        resolve(config)
      })
    })
  }
}

export const getWeedmapTags = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getWeedmapTagsAPI(), dispatch).then((tags) => {
        dispatch(setWeedmapTags(tags))
        resolve(tags)
      })
    })
  }
}

export const updateWeedmapAccount = commonActionAPIHit(updateWeedmapAccountAPI)
export const updateWeedmapMapping = commonActionAPIHit(updateWeedmapMappingAPI)
export const deleteWeedmapAccount = commonActionAPIHit(deleteWeedmapAccountAPI)
export const updateWeedmapPin = commonActionAPIHit(updateWeedmapAPIKeyAPI)
export const syncWeedmapMenu = commonActionAPIHit(
  syncWeedmapMenuAPI,
  null,
  'Weedmaps sync has started. It may take a few minutes',
)
export const resetSyncWeedmapMenu = commonActionAPIHit(
  resetSyncWeedmapMenuAPI,
  null,
  'Weedmaps sync has started. It may take a few minutes',
)
export const resetAndDeleteWeedmap = commonActionAPIHit(resetAndDeleteWeedmapAPI)
export const generateToken = commonActionAPIHit(generateTokenAPI)
export const renewToken = commonActionAPIHit(renewTokenAPI)
export const discontinueWeedmapsItems = commonActionAPIHit(
  discontinueWeedmapsItemsAPI,
  null,
  'Weedmaps menu is discontinuing, please wait for your menu to clear',
)

// webhooks api

export const getWebHooks = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getWebHooksAPI(), dispatch).then((webHooks) => {
        dispatch(setWebHooks(webHooks))
        resolve(webHooks)
      })
    })
  }
}

export const updateWebHook = commonActionAPIHit(updateWebHookAPI)
export const createWebHook = commonActionAPIHit(createWebHookAPI)

export const getHubsList = (apiKey) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      if (apiKey) {
        addMessageCurry(getHubListAPI(apiKey), dispatch).then((hubsList) => {
          dispatch(setHubList({ apiKey, hubsList }))
          resolve(hubsList)
        })
      }
    })
  }
}

export const updateShopOnFleetSettings = commonActionAPIHit(updateShopOnFleetSettingsAPI)
export const updateShopOnFleetKey = commonActionAPIHit(updateShopOnFleetKeyAPI)

export const getEmployeeList = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getEmployeeListAPI(), dispatch).then((employeeList) => {
        dispatch(setEmployeeList(employeeList))
        resolve(employeeList)
      })
    })
  }
}

export const getOnFleetTeams = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getOnFleetTeamsAPI(), dispatch).then((teamList) => {
        dispatch(setOnFleetTeams(teamList))
        resolve(teamList)
      })
    })
  }
}
export const getWorkersByTeamOnFleet = (teamId, shopId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getWorkersByTeamOnFleetAPI(teamId, shopId), dispatch).then((workers) => {
        resolve(workers)
      })
    })
  }
}

export const getSpringBigList = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getSpringBigListAPI(), dispatch).then((springBigList) => {
        dispatch(setSpringBigList(springBigList))
        resolve(springBigList)
      })
    })
  }
}

export const getTookanAccountList = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getTookanAccountListAPI(), dispatch).then((tookanAccounts) => {
        resolve(tookanAccounts)
      })
    })
  }
}

export const getTookanTeams = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getTookanTeamsAPI(data), dispatch).then((teamList) => {
        dispatch(setTookanTeams(teamList))
        resolve(teamList)
      })
    })
  }
}

export const createAgentWithTookan = (employeeId, data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(createAgentWithTookanAPI(employeeId, data), dispatch).then((response) => {
        resolve(response)
      })
    })
  }
}

export const updateAgentWithTookan = (employeeId, data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(updateAgentWithTookanAPI(employeeId, data), dispatch).then((response) => {
        resolve(response)
      })
    })
  }
}

export const getSpenceAccountList = (companyId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getSpenceAccountListAPI(companyId), dispatch).then((spenceAccounts) => {
        resolve(spenceAccounts)
      })
    })
  }
}

export const getACHAccountList = (companyId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getACHAccountListAPI(companyId), dispatch).then((achAccounts) => {
        resolve(achAccounts)
      })
    })
  }
}

export const getOnFleetErrorLogByShop = commonActionAPIHit(onFleetErrorLogByShopAPI)
export const getSynchronizedTeamsByShop = commonActionAPIHit(onFleetTeamsByShopAPI)
export const synchronizeTeams = commonActionAPIHit(
  synchronizeTeamsAPI,
  null,
  'The Onfleet teams for this shop have been synchronized',
)
export const updateEmployeeOnFleet = commonActionAPIHit(updateEmployeeOnFleetAPI)
export const syncEmployeeOnFleet = commonActionAPIHit(syncEmployeeOnFleetAPI)
export const createWorkerOnFleet = commonActionAPIHit(createWorkerOnFleetAPI)
export const removeWorkerOnFleet = commonActionAPIHit(removeWorkerOnFleetAPI)
export const updateSpringBigInfo = commonActionAPIHit(updateSpringBigInfoAPI)
export const createSpringBigInfo = commonActionAPIHit(createSpringBigInfoAPI)
export const syncSpringBigMembers = commonActionAPIHit(syncSpringBigMembersAPI)
export const createTookanAccount = commonActionAPIHit(createTookanAccountAPI)
export const updateTookanAccount = commonActionAPIHit(updateTookanAccountAPI)
export const deleteTookanAccount = commonActionAPIHit(deleteTookanAccountAPI)
export const syncTeamWithTookan = commonActionAPIHit(syncTeamWithTookanAPI)
export const getTookanErrorLogs = commonActionAPIHit(getTookanErrorLogsAPI)
export const createSpenceAccount = commonActionAPIHit(createSpenceAccountAPI)
export const updateSpenceAccount = commonActionAPIHit(updateSpenceAccountAPI)
export const deleteSpenceAccount = commonActionAPIHit(deleteSpenceAccountAPI)
export const getLastsyncSpringBigMembers = commonActionAPIHit(getLastSyncSpringbigAPI)
export const createACHAccount = commonActionAPIHit(createACHAccountAPI)
export const updateACHAccount = commonActionAPIHit(updateACHAccountAPI)
export const deleteACHAccount = commonActionAPIHit(deleteACHAccountAPI)



// WEBPACK FOOTER //
// ./src/actions/integration.js